export default function WhyChooseSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-6xl mx-auto">
          <div className="w-full lg:w-2/5">
            <div className="inline-block px-3 py-1 border border-foreground-300 rounded-full mb-6">
              <span className="text-xs font-medium text-foreground-700 tracking-wider">
                WHY US
              </span>
            </div>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4 leading-tight">
              別讓資訊落差
              <br />
              <span className="text-foreground-600">成為企業成長的隱形成本</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              政府資源、產學合作、AI 工具與 ESG 趨勢看似豐富，卻常分散在不同單位與管道中。企業若缺乏專業判斷，容易錯過適合的時機，也可能投入時間後無法真正落地。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8">
              得運智科協助企業梳理現況、確認需求、評估資源與規劃執行路徑，讓每一次升級不是盲目追趨勢，而是有策略、有方法、有依據地前進。
            </p>
            <div className="flex flex-wrap gap-10">
              <div>
                <p className="text-3xl md:text-4xl font-bold text-primary-600">500+</p>
                <p className="text-sm text-foreground-600 mt-1">輔導時數</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-bold text-primary-600">98%</p>
                <p className="text-sm text-foreground-600 mt-1">客戶續約</p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-3/5 relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20consultant%20having%20strategic%20discussion%20with%20enterprise%20owner%20in%20modern%20conference%20room%2C%20corporate%20digital%20transformation%20planning%2C%20whiteboard%20with%20business%20strategy%2C%20warm%20professional%20lighting%20with%20blue%20accent%20colors%2C%20sophisticated%20office%20interior%20with%20glass%20walls%20and%20modern%20furniture%2C%20professional%20consulting%20atmosphere&width=600&height=700&seq=why-1&orientation=portrait"
                  alt="企業顧問諮詢"
                  className="w-full h-64 md:h-80 object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Business%20analytics%20dashboard%20with%20colorful%20charts%20and%20data%20visualization%20on%20large%20screen%2C%20corporate%20data%20monitoring%20and%20KPI%20tracking%2C%20modern%20professional%20office%20setting%2C%20blue%20and%20gold%20color%20scheme%20in%20technology%20environment%2C%20professional%20data%20analyst%20workspace%2C%20sophisticated%20corporate%20technology%20atmosphere&width=600&height=700&seq=why-2&orientation=portrait"
                  alt="數據分析儀表板"
                  className="w-full h-64 md:h-80 object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}